import * as actionTypes from "../constants";
import { updateObject } from "../../utils";

const initialState = {
  loading: false,
  token: null,
  error: false,
};

const setIsLoading = (state, action) => {
  return updateObject(state, {
    loading: action.isLoading,
  });
};

const setSessionError = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const setToken = (state, action) => {
  return updateObject(state, {
    token: action.token,
  });
};

const action = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_SET_IS_LOADING:
      return setIsLoading(state, action);
    case actionTypes.ACTION_SET_TOKEN:
      return setToken(state, action);
    case actionTypes.ACTION_SET_ERROR:
      return setSessionError(state, action);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default action;
